import React, {Component} from 'react';
import request from "superagent";
import InnerHTML from "./TemplateImporter/TemplateImporter.js";
import REST from "../REST";
import TRACKING from "../DataTrackingPoints";
import DialogBox from "../../Shared/DialogBox";

export default class ChartComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            extHTML: {__html: ""},
            chartData:[],
            student: this.props.student
        }

        this.recordHowToUseData = this.recordHowToUseData.bind(this);
        this.recordViewMicroDataChart = this.recordViewMicroDataChart.bind(this);
        this.recordViewMacroDataChart = this.recordViewMacroDataChart.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleResourceAnalytics = this.handleResourceAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);

    }

    componentDidMount() {
        request.get("/charts/chartTemplate.html").then(
            res => {
                console.log(res);
                this.setState({
                    extHTML: {
                        __html: res.text
                    }
                });
            }).catch(err => {
            //handle your error here
        });
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleSurveyBack(){

    }

    handleResourceAnalytics(resourceId){
        this.setState({
                analytics: {
                    type: TRACKING.RESOURCES_DOWNLOAD,
                    metadata: {
                        resourceId: resourceId
                    }
                }
            },
            ()=> this.handleAnalytics());
    }

    recordHowToUseData(app, PNModel){
        this.setState({
                analytics: {
                    type: TRACKING.HOW_TO_USE_DATA,
                    metadata: {app: app, PNModel: PNModel}
                }
            },
            ()=> this.handleAnalytics());
    }

    recordViewMicroDataChart(app, studentUserId, level){
        let appType;
        switch(app){
            case 'Maze': appType = TRACKING.MAZE_DATACHART_VIEW_MICRO;
                break;
            case "Slash": appType = TRACKING.SLASH_DATACHART_VIEW_MICRO;
                break;
            case "WordMark": appType = TRACKING.WORDMARK_DATACHART_VIEW_MICRO;
                break;
            case 'KidSign': appType = TRACKING.KSS_DATACHART_VIEW_MICRO;
                break;
            case 'KidSpeak': appType = TRACKING.KS_DATACHART_VIEW_MICRO;
                break;
            case "Picture Naming":appType = TRACKING.PN_DATACHART_VIEW_MICRO;
                break;
            case "Word Sign/Say":appType = TRACKING.WSS_DATACHART_VIEW_MICRO;
                break;
            case "CopyRight":appType = TRACKING.COPYRIGHT_DATACHART_VIEW_MICRO;
                break;

        }
        this.setState({
                analytics: {
                    type: appType,
                    metadata: {userId: studentUserId, level: level}
                }
            },
            ()=> this.handleAnalytics());
    }

    recordViewMacroDataChart(app, studentUserId){
        let appType;
        switch(app){
            case 'Maze': appType = TRACKING.MAZE_DATACHART_VIEW_MACRO;
                break;
            case "Slash": appType = TRACKING.SLASH_DATACHART_VIEW_MACRO;
                break;
            case "WordMark": appType = TRACKING.WORDMARK_DATACHART_VIEW_MACRO;
                break;
            case 'KidSign': appType = TRACKING.KSS_DATACHART_VIEW_MACRO;
                break;
            case 'KidSpeak': appType = TRACKING.KS_DATACHART_VIEW_MACRO;
                break;
            case "Picture Naming":appType = TRACKING.PN_DATACHART_VIEW_MACRO;
                break;
            case "Word Sign/Say":appType = TRACKING.WSS_DATACHART_VIEW_MACRO;
                break;
            case "CopyRight":appType = TRACKING.COPYRIGHT_DATACHART_VIEW_MACRO;
                break;
        }
        this.setState({
                analytics: {
                    type: appType,
                    metadata: {userId: studentUserId}
                }
            },
            ()=> this.handleAnalytics());
    }

    render() {
        window.recordHowToUseData = this.recordHowToUseData;
        window.recordViewMacroDataChart = this.recordViewMacroDataChart;
        window.recordViewMicroDataChart = this.recordViewMicroDataChart;
        window.handleResourceAnalytics = this.handleResourceAnalytics;

        if(this.props.globalData.length>0) {
            window.chartComponentContext = {
                chartData:this.props.globalData,
                student:this.props.student,
                updateNote: this.props.updateNote,
                appName:this.props.appName,
                chartRules:this.props.chartRules,
                xLabel:this.props.xLabel,
                yLabel:this.props.yLabel,
                PNModel: this.props.PNModel
            }
        }else{
            window.chartComponentContext = {
                chartData:[],
                student:null,
                updateNote:null,
                chartRules:this.props.chartRules,
                xLabel:this.props.xLabel,
                yLabel:this.props.yLabel,
                PNModel: this.props.PNModel
            };
        }

        let appName;
        switch (this.props.appName){
            case 'Maze': appName = "MazeDataChart";
                break;
            case "Slash": appName = "SlashDataChart";
                break;
            case "WordMark": appName = "WMDataChart";
                break;
            case 'KidSign': appName = "KSSDataChart";
                break;
            case 'KidSpeak': appName = "KSDataChart";
                break;
            case "Picture Naming": appName = "PNDataChart";
                break;
            case "Word Sign/Say": appName = "WSSDataChart";
                break;
            case "CopyRight": appName = "CRDataChart";
                break;
        }

            return (
                <div>
                    <DialogBox surveyModal role={'teacher'} app={appName} userId={this.props.teacher?this.props.teacher.id:null} active={true} surveyBack={this.handleSurveyBack}/>
                    <InnerHTML html={this.state.extHTML.__html} />
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Shared/Chart/Chart.js